var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon feather-plus",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.5 11.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 525",
    d: "M5.75 0v11.5",
    fill: "none",
    stroke: "#333",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 526",
    d: "M0 5.75h11.5",
    fill: "none",
    stroke: "#333",
    strokeLinejoin: "round"
  })));
}

export default __webpack_public_path__ + "04f62a69022f03eb51cac3d5460a1659.svg";
export { SvgPlus as ReactComponent };